

export function wixChat1_viewportEnter(event) {
היי
}

export function wixChat1_viewportEnter_1(event) {
	//Add your code for this event here: 
}